import { InvoiceLineKind } from "@api/shared-runtime/enums";

const CENTS_PER_UNIT = 100;

type InvoiceLineLike = { kind: InvoiceLineKind; amount: string };

export function groupInvoiceLines<T extends InvoiceLineLike>(
  lines: T[],
): { saileLines: T[]; wageLines: T[] } {
  return {
    saileLines: lines.filter(
      (line) => line.kind !== InvoiceLineKind.WagePassThrough,
    ),
    wageLines: lines.filter(
      (line) => line.kind === InvoiceLineKind.WagePassThrough,
    ),
  };
}

export function sumLineAmounts(lines: InvoiceLineLike[]): string {
  const cents = lines.reduce(
    (sum, line) => sum + Math.round(Number(line.amount) * CENTS_PER_UNIT),
    0,
  );
  return (cents / CENTS_PER_UNIT).toFixed(2);
}
